/**
 * The use case of a search or ranking request
 *
 * This should be kept in sync with SearchUseCase in website/app/server/services/Listings/graphql/schema.ts
 *
 */
export enum SearchUseCase {
  /* Search listings (mobile, desktop, iOS, Android) */
  SEARCH = "SEARCH",

  /* Related or similar content (e.g. "more like this") */
  RELATED_CONTENT = "RELATED_CONTENT",

  /* Category page listings */
  CATEGORY_CONTENT = "CATEGORY_CONTENT",

  /* Non personalized exploration (e.g. logged out homepage carousels) */
  DISCOVER = "DISCOVER",

  /* Personalized feed (e.g. parent dashboard / logged in homepage carousels) */
  FEED = "FEED",

  /* Deprecated -- No longer in use, but kept for backward compatibility */
  CDP_AS_CLP = "CDP_AS_CLP",

  /* Custom use case, if none of the above apply */
  CUSTOM = "CUSTOM",

  UNKNOWN_USE_CASE = "UNKNOWN_USE_CASE",
}
